import { render, staticRenderFns } from "./CategoryDetails.vue?vue&type=template&id=b3c5d85e&scoped=true&lang=html"
import script from "./CategoryDetails.vue?vue&type=script&lang=js"
export * from "./CategoryDetails.vue?vue&type=script&lang=js"
import style0 from "./CategoryDetails.vue?vue&type=style&index=0&id=b3c5d85e&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b3c5d85e",
  null
  
)

export default component.exports